import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Button from '../../../../UniformComponents/Button'
import CustomTagGroup from './CustomTagGroup'
import { renderField } from './utils'

@observer
class CreateEdit extends Component {
    constructor(props) {
        super(props)
        const { store, id } = this.props
        store.initEdit(parseInt(id, 10))
    }

    renderFields = () => {
        // CustomBenchmarks form
        const { store } = this.props
        const { onBlur, register, unregister } = store

        return store.getFormFields().map((field) => (
            renderField(field, onBlur, register, unregister, store)
        ))
    }

    renderSections = () => {
        // CustomTags form only
        const renderFieldGroup = (section) => {
            const { store } = this.props
            const { onBlur, register, unregister } = store

            return store.getFormFields()
                .filter((field) => field.customTagSection === section)
                .map((field) => renderField(field, onBlur, register, unregister, store))
        }

        return (
            <Fragment>
                <div className="customTag__section-title">New custom tag</div>
                <div className="customTag__section flex">{renderFieldGroup(1)}</div>

                <div className="customTag__section-title">Applicable client rules</div>
                <div className="customTag__section">{renderFieldGroup(2)}</div>

                <div className="customTag__section-title">Applicable resources rules</div>
                <div className="customTag__section">{renderFieldGroup(3)}</div>

                <div className="customTag__section-title">Tag configuration</div>
                <div className="customTag__section">{renderFieldGroup(4)}</div>
            </Fragment>
        )
    }

    render() {
        const { store, history } = this.props
        const {
            save, isLoading, cancel, isCustomBenchmark, currentTagGroup,
        } = store

        return (
            <Fragment>
                {!isLoading && (isCustomBenchmark ? this.renderFields() : this.renderSections())}
                {!isLoading && !isCustomBenchmark && currentTagGroup && (
                    <CustomTagGroup
                        store={store}
                        group={currentTagGroup}
                    />
                )}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <Button
                        label={i18n.t('cancel')}
                        onClick={() => cancel(history)}
                        cssClass="tertiary regular"
                    />
                    <Button
                        label={i18n.t('save')}
                        onClick={() => save(history)}
                        cssClass="primary regular"
                    />
                </div>
            </Fragment>
        )
    }
}

export default CreateEdit
